import { render } from "./BAboutUs.vue?vue&type=template&id=c94c5a3c&scoped=true"
import script from "./BAboutUs.vue?vue&type=script&lang=js"
export * from "./BAboutUs.vue?vue&type=script&lang=js"

import "./BAboutUs.vue?vue&type=style&index=0&id=c94c5a3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c94c5a3c"]])

export default __exports__